export default __webpack_public_path__ + "static/media/AnimeCover.272f95d1.jpg";